export default __webpack_public_path__ + "static/media/IMG-20230108-WA0056.049e4ac2.jpg";